
<div v-if="show">
    <d-contract-history
        v-model  = "history.show"
        :unit    = "history.unit"
        :history = "history.data"
        :contract= "contract"
    />

    <c-card-iterator
        :items          = "filteredUnits"
        :label          = "fullTitle"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "itemHeight"
        :total-visible  = "5"
        :filter-height  = "235"
        :filter         = "match"
        :zoom           = "false"
        :left-arrow     = "false"
        :header-color   = "headerColor"
        ref             ="iterator"
    >
        <template v-slot:toolbar>
            <c-toolbar-button
                v-if    = "allowNew"
                class   = "mr-3"
                style   = "margin-top: -2px;"
                icon    = "mdi-plus"
                size    = "22"
                color   = "white"
                tooltip = "Neue Anlage"
                @click  = "onNewUnit"
            />
            <c-toolbar-button
                v-if    = "allowBulkEdit && isDataAdmin"
                class   = "mr-3"
                style   = "margin-top: -2px;"
                icon    = "mdi-pencil-box-multiple-outline"
                size    = "22"
                color   = "white"
                tooltip = "Bulk Edit"
                @click  = "onBulkEdit"
            />


        </template>
        <template v-slot:card="{ item }">
            <c-site-card
                :site        = "item"
                :selected    = "item.checked"
                :selectable  = "isSelectable"
                :height      = "itemHeight"
                @click       = "onEdit"
                @site        = "onSite"
                @assign      = "onAssign"
                @deselect    = "onDissolve"
            >
                <template v-slot:editor="{ site }" >
                    <div v-if="isAssignedToContract(site)">
                        <slot name="editor" v-bind:site="site"></slot>
                    </div>
                </template>
                <template v-slot:toolbar>
                    <c-toolbar-button
                        style   = "margin-left: 8px; margin-top: -2px"
                        v-if    = "contract"
                        size    = "22"
                        color   = "primary"
                        icon    = "mdi-history"
                        tooltip = "Historie zum Vertrag"
                        @click  = "onContractHistory(item, contract.type.id)"
                    />
                </template>
            </c-site-card>
        </template>
        <template v-slot:filter >
            <div>
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Anlagen im Liftmanagement"
                            v-model = "filter.active"
                            class   = "mt-0"
                            :ripple = "false"
                            hide-details
                            @change = "onFilterChanged"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame" v-if="orphan">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Liftmanagement Vertrag wird beendet"
                            v-model = "filter.terminate"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onFilter"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame" v-if="orphan">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Anlagen ohne Liftmanagement"
                            v-model = "filter.orphan"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onFilter"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "stillgelegte / inaktive Anlagen"
                            v-model = "filter.inactive"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onFilterChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-divider class="mt-2 mb-1" />

                <v-row class="no-frame" v-if="orphan">
                    <v-col class="no-frame v-flex">
                        <v-select
                            v-model = "companyFilter"
                            label   = "Serviceunternehmen"
                            :items  = "companies"
                            @change = "onFilter"
                            hide-details
                        />
                    </v-col>
                </v-row>

            </div>
        </template>
        <template v-slot:prefix>
            <div class="ml-n2" style="margin-top: -2px">
                <c-toolbar-button
                    v-if  = "isAssignModePossible  && customer"
                    size  = "22"
                    color = "white"
                    icon   = "mdi-plus-circle"
                    @click = "onStartAssingMode"
                />
                <c-toolbar-button
                    v-if  = "isItemSelected && assignUnitMode && customer"
                    size  = "22"
                    color = "white"
                    icon  = "mdi-arrow-left-circle"
                    @click = "onEndAssingMode"
                />
            </div>
        </template>
    </c-card-iterator>
</div>
